import { useCallback, useState } from "react";
import axios from "axios";

import { useMessage } from "./useMessage";
import appconfig from "../config.json";

export const useParameters = () => {
  const { showMessage } = useMessage();
  const [deviceNames, setDeviceNames] = useState<Array<string>>([]);
  const [typeNames, setTypeNames] = useState<Array<string>>([]);

  const PARMS_MANAGER_URL: string = appconfig["IOT_MANAGEMENT_API_URL"];

  const getDeviceNames = useCallback(() => {

    type DeviceParam = {
      DeviceName: string;
    };

    axios
      .get<Array<DeviceParam>>(PARMS_MANAGER_URL + "/parameters/device", {
        headers: {}
      })
      .then((res) => {
        var names = res.data.map((val)=>{return val['DeviceName'];});
        setDeviceNames(names);
      })
      .catch(() =>
        showMessage({ title: "パラメータの取得に失敗しました", status: "error" })
      )
  },[]);

  const getTypeNames = useCallback(() => {

    type TypeParam = {
      TypeName: string;
    };

    axios
      .get<Array<TypeParam>>(PARMS_MANAGER_URL + "/parameters/entitytype", {
        headers: {}
      })
      .then((res) => {
        var names = res.data.map((val)=>{return val['TypeName'];});
        setTypeNames(names);
      })
      .catch(() =>
        showMessage({ title: "パラメータの取得に失敗しました", status: "error" })
      )
  },[]);

  return { getDeviceNames, getTypeNames, deviceNames, typeNames };
};
